import SideMenu from '@/containers/side-menu/SideMenu.vue';
import VehiclePixBying from '@/pages/vehicle-pix-bying/VehiclePixBying';

export default {
  path: '/vehicle-pix-bying',
  name: 'VehiclePixBying',
  components: {
    mainContent: VehiclePixBying,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'vehicle-pix-transactions',
    },
    breadcrumb: {
      title: 'Pix Comprados',
      paths: [
        { title: 'Veículo' },
        { title: 'Pix Comprados' },
      ],
    },
  },
};
